module.exports = __webpack_public_path__ + "static/media/bmu_logo.4b9d633e.svg";